export const QA_NAME_APPLICANT_PROFILE_EMAILS = 'applicantProfileEmails'

export const QA_NAME_APPLICANT_PROFILE_EMAILS_COMPOSE =
  'applicantProfileEmailsCompose'

export const QA_NAME_APPLICANT_PROFILE_EMAILS_RETRY =
  'applicantProfileEmailsRetry'

export const QA_NAME_APPLICANT_PROFILE_EMAILS_TABLE = 'applicantEmails'

export const APPLICANT_PROFILE_EMAILS_PAGE_SIZE = 20

export const APPLICANT_PROFILE_EMAILS_READ_KEY_SEPARATOR = '|'

export const APPLICANT_PROFILE_EMAILS_DRAFT_PREFIX =
  'rental-portal-applicant-profile-emails'

export const APPLICANT_PROFILE_EMAILS_SKELETON_ROWS = 3

export const APPLICANT_PROFILE_EMAILS_COLUMN_NAME = {
  Participant: 'participant',
  SentAt: 'sent_at',
  Subject: 'subject',
}

export const APPLICANT_PROFILE_EMAILS_COLUMNS_CONFIG = {
  [APPLICANT_PROFILE_EMAILS_COLUMN_NAME.Participant]: {
    index: 0,
    name: APPLICANT_PROFILE_EMAILS_COLUMN_NAME.Participant,
    ordering_field: null,
    title: 'EmailTable.ParticipantsColumnTitleKey',
    visible: true,
    width: 240,
  },
  [APPLICANT_PROFILE_EMAILS_COLUMN_NAME.SentAt]: {
    index: 2,
    name: APPLICANT_PROFILE_EMAILS_COLUMN_NAME.SentAt,
    ordering_field: null,
    title: 'EmailTable.DateColumnTitleKey',
    visible: true,
    width: 200,
  },
  [APPLICANT_PROFILE_EMAILS_COLUMN_NAME.Subject]: {
    index: 1,
    name: APPLICANT_PROFILE_EMAILS_COLUMN_NAME.Subject,
    ordering_field: null,
    title: 'EmailTable.MessageColumnTitleKey',
    visible: true,
  },
}

export const APPLICANT_PROFILE_EMAILS_STATE = {
  empty: 'empty',
  error: 'error',
  loading: 'loading',
  table: 'table',
}

export const APPLICANT_PROFILE_EMAILS_SEND_ERROR_FIELD = {
  account: 'account',
  files: 'files',
}

export const APPLICANT_PROFILE_EMAILS_NO_ADDRESS_REASON = 'no_address'
